// BUILD-046 pass F1 (Owner direction 2026-10-25): the tab strip of the HQ administration area (adminAreaModel.ts). Drawn above the Document Manager (/admin) and the Work groups page (/work-groups) only
// for a person who may see both; a person with one of them sees that page alone. A convenience, not a control: the server checks the authority of each page on every request.
import { NavLink } from 'react-router-dom';
import { useHqAccess } from '../settings/hqAccess';
import { useWorkMe } from '../../components/sharedTasks/useWorkMe';
import { buildAdminTabs, showAdminTabs } from './adminAreaModel';

export function AdminAreaTabs() {
  const hq = useHqAccess();
  const { me } = useWorkMe();
  // BUILD-046 integration: the HQ administration page (/admin) is offered to exactly the people the HQ sidebar offers it to (AppLayout.tsx `showHqAdministration`, from the server-resolved HQ permissions),
  // not by sign-in group. A convenience only: the server authorizes every page and request.
  const isAdmin = hq.can('hq.users.manage') || hq.canManageAccess || ['hq.integrations.view', 'hq.automations.view', 'hq.supplier-pricing.admin', 'hq.documents.manage'].some((key) => hq.can(key));
  const tabs = buildAdminTabs({ isAdmin, canAdministerGroups: me?.canAdministerGroups === true });
  if (!showAdminTabs(tabs)) return null;
  return (
    <nav aria-label="HQ administration" data-testid="admin-area-tabs" className="border-b border-gray-200 bg-white px-4 lg:px-6">
      <ul className="mx-auto flex max-w-5xl gap-1">
        {tabs.map((tab) => (
          <li key={tab.key}>
            <NavLink
              to={tab.to}
              data-testid={`admin-tab-${tab.key}`}
              className={({ isActive }) =>
                `-mb-px inline-block border-b-2 px-3 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4AABDE] ${isActive ? 'border-[#4AABDE] text-gray-900' : 'border-transparent text-gray-600 hover:text-gray-900'}`
              }
            >
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
